import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";

export const TableCellRecord = Record({
  row: null,
  rowId: null,
  column: null,
  columnId: null,
  value: null,
  disabled: false,
  isWarning: false,
  warningMessage: null,
  selected: false,
  placeholder: null,
  startDate: null,
  latestStartDate: null,
  earliestEndDate: null,
  endDate: null,
  durationToEarliestEnd: null,
  duration: null,
  ongoing: false,
  startLabel: "",
  endLabel: "",
  isAvatar: false,
  color: null,
  image: null,
  icon: null,
  iconColor: null,
  isStruckOut: false,
  // So far for the identifier (list) size only
  size: SizeRecord(),
  remaining: 0
});

createFromJS.registerCallback("TableCellRecord", createFromJS.createPrimitiveCallback(TableCellRecord));
